$(function() {
  $('body').on('click','.list-menu .header__menu-item', function() {
    let thisMegaMenu = $(this).siblings('.mega-menu__content');
    thisMegaMenu.find('ul.L2.on').removeClass('on');
    thisMegaMenu.find('ul.L2:first').addClass('on');
  });
  $('body').on('click','.mega-menu__content.two-column .link-L2', function(e) {
    $('.mega-menu__content.two-column .link-L2').siblings('ul.on').removeClass('on');
    
    if($(this).siblings('ul').length > 0) {
      e.preventDefault();
      $(this).siblings('ul').addClass('on');
    }
  });
});